import { Box, Paper, Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@material-ui/core'
import React, { ChangeEvent, Fragment, useState } from 'react'
import { useQuery } from 'react-query'
import { StyledTableCell } from '../../components/CustomTable'
import { useFeedback } from '../../components/Feedback'
import NationalCodeSelect from '../../components/NationalCodeSelect'
import moment from 'moment'
import { addChannel, listChannel, listChannelReports, listChannelUser, updateChannel } from '../../utils/api'
import { formatPrice } from '../../utils'
const defaultChannel = {
    channel_id: '',
    create_time: 0,
    mobile: '',
    national_code: '86',
    display_name: '',
    name: '',
    remark: '',
    qrcode: '',
    present_coin: 0,
    visit_count: 0,
    sales: 0
}
const SalesChannel = () => {
    const { showLoading, hideLoading, showToast } = useFeedback()
    const [showEdit, setShowEdit] = useState(false)
    const [showQRCode, setShowQRCode] = useState(false)
    const [showReports, setShowReports] = useState(false)
    const [showUsers, setShowUsers] = useState(false)
    const [channel, setChannel] = useState<SalesChannel>(defaultChannel)
    const { data: channels, refetch } = useQuery<SalesChannel[]>('listchannel', () => listChannel())
    const { data: channelUsers, refetch: usersRefetch } = useQuery<{ [key: string]: string }[]>(['listchanneluser', channel.id], () => listChannelUser(channel.id))
    const { data: channelReports, refetch: reportsRefetch } = useQuery<ChannelSalesReport[]>(['channelreports', channel.id], () => listChannelReports(channel.id))
    const handleShowEdit = (c: SalesChannel, type?: 'edit' | 'qrcode' | 'users' | 'reports') => () => {
        setChannel(c)
        if (!type || type === 'edit') {
            setShowEdit(true)
        } else if (type === 'qrcode') {
            setShowQRCode(true)
        } else if (type === 'reports') {
            setShowReports(true)
        } else {
            setShowUsers(true)
        }
    }

    const handleChannelChange = (key: 'name' | 'mobile' | 'national_code' | 'present_coin' | 'remark' | 'display_name') => (event: ChangeEvent<HTMLInputElement>) => {
        setChannel({ ...channel, [key]: event.target.value })
    }

    const handleEdit = () => {
        showLoading('')
        if (channel.id) {
            updateChannel(channel.id, channel.name, channel.remark, channel.present_coin, channel.display_name).then(res => {
                showToast('更新成功')
                hideLoading()
                setShowEdit(false)
                setChannel(defaultChannel)
                refetch()
            }).catch(e => {
                hideLoading()
                showToast(e.msg)
            })
        } else {
            addChannel(channel.name, channel.remark, channel.present_coin, channel.display_name, channel.mobile, channel.national_code).then(res => {
                showToast('添加成功')
                hideLoading()
                setShowEdit(false)
                refetch()
                setChannel(defaultChannel)
            }).catch(e => {
                hideLoading()
                showToast(e.msg)
            })
        }
    }

    return <Fragment>
        <Box>
            <Button onClick={handleShowEdit(defaultChannel)}>添加渠道</Button>
            <Box mt={2}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>渠道ID</StyledTableCell>
                                <StyledTableCell align="center">渠道名称</StyledTableCell>
                                <StyledTableCell align="center">用户端渠道名称</StyledTableCell>
                                <StyledTableCell align="center">备注</StyledTableCell>
                                <StyledTableCell align="center">扫码次数</StyledTableCell>
                                <StyledTableCell align="center">获得手机号数</StyledTableCell>
                                <StyledTableCell align="center">转化注册用户数</StyledTableCell>
                                <StyledTableCell align="center">转化付费用户数</StyledTableCell>
                                <StyledTableCell align="center">累计消费金额</StyledTableCell>
                                <StyledTableCell align="center">累计实际到账（估算）</StyledTableCell>
                                <StyledTableCell align="center">新用户赠送爱豆数</StyledTableCell>
                                <StyledTableCell align="center">二维码</StyledTableCell>
                                <StyledTableCell align="center">用户列表</StyledTableCell>
                                <StyledTableCell align="center">操作</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {channels?.map(c => <TableRow key={c.id}>
                                <TableCell>{c.channel_id}</TableCell>
                                <TableCell align="center">{c.name}</TableCell>
                                <TableCell align="center">{c.display_name}</TableCell>
                                <TableCell align="center">{c.remark}</TableCell>
                                <TableCell align="center">{c.visit_count}</TableCell>
                                <TableCell align="center">{c.mobile_count}</TableCell>
                                <TableCell align="center">{c.client_count}</TableCell>
                                <TableCell align="center">{c.pay_count}</TableCell>
                                <TableCell align="center">{formatPrice(c.sales)}元</TableCell>
                                <TableCell align="center">{formatPrice(c.income)}元</TableCell>
                                <TableCell align="center">{c.present_coin}</TableCell>
                                <TableCell align="center">
                                    <Button variant="text" onClick={handleShowEdit(c, 'qrcode')}>查看</Button>
                                </TableCell>
                                <TableCell align="center">
                                    <Button variant="text" onClick={handleShowEdit(c, 'users')}>查看</Button>
                                </TableCell>
                                <TableCell align="center">
                                    <Button variant="text" onClick={handleShowEdit(c, 'edit')}>编辑</Button>
                                    <Button variant="text" onClick={handleShowEdit(c, 'reports')}>月度统计</Button>
                                </TableCell>
                            </TableRow>)}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>

        <Dialog open={showQRCode} onClose={() => setShowQRCode(false)}>
            <DialogContent>
                <img src={channel.qrcode} width="300px" height="300px" />
            </DialogContent>
        </Dialog>

        <Dialog open={showUsers} onClose={() => setShowUsers(false)} >
            <TableContainer style={{ minWidth: '560px' }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>手机号</StyledTableCell>
                            <StyledTableCell align="center">注册时间</StyledTableCell>
                            <StyledTableCell align="center">付费金额</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {channelUsers?.map(u => <TableRow key={u.id}>
                            <TableCell>{`+${u.national_code}${u.mobile}`}</TableCell>
                            <TableCell align="center">{u.signup_time ? moment(u.signup_time).format('YYYY-MM-DD HH:mm') : ''}</TableCell>
                            <TableCell align="center">{formatPrice(+u.amount)}元</TableCell>
                        </TableRow>)}
                    </TableBody>
                </Table>
            </TableContainer>
        </Dialog>

        <Dialog open={showReports} onClose={() => setShowReports(false)} >
            <TableContainer style={{ minWidth: '560px' }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>月份</StyledTableCell>
                            <StyledTableCell align="center">累计消费金额</StyledTableCell>
                            <StyledTableCell align="center">累计实际到账（估算）</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {channelReports?.map(r => <TableRow key={r.id}>
                            <TableCell>{r.month}</TableCell>
                            <TableCell align="center">{formatPrice(r.sales)}元</TableCell>
                            <TableCell align="center">{formatPrice(r.income)}元</TableCell>
                        </TableRow>)}
                    </TableBody>
                </Table>
            </TableContainer>
        </Dialog>

        <Dialog open={showEdit} maxWidth="lg" onClose={() => setShowEdit(false)}>
            <DialogTitle>
                {channel.id ? '更新渠道' : '添加渠道'}
            </DialogTitle>
            <DialogContent >
                <Box>
                    <Box display="flex" justifyContent="space-between">
                        <TextField label="渠道名称" value={channel.name} onChange={handleChannelChange('name')} />
                        {!channel.id && <TextField
                            style={{ marginLeft: '16px' }}
                            value={channel.mobile}
                            onChange={handleChannelChange('mobile')}
                            InputProps={{ startAdornment: <NationalCodeSelect value={channel.national_code} onChange={handleChannelChange('national_code')} /> }}
                            label="手机号" />}
                        <TextField style={{ marginLeft: '16px' }} label="新用户赠送豆数" value={channel.present_coin} onChange={handleChannelChange('present_coin')} />
                    </Box>
                    <Box mt={1.5}>
                        <TextField label="用户端渠道名称" value={channel.display_name} onChange={handleChannelChange('display_name')} />
                        <TextField style={{ marginLeft: '16px' }} label="渠道备注" value={channel.remark} onChange={handleChannelChange('remark')} />
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="text" onClick={() => setShowEdit(false)}>取消</Button>
                <Button onClick={handleEdit}>确定</Button>
            </DialogActions>
        </Dialog>
    </Fragment>
}

export default SalesChannel